/**
 * PATH: packages/ui/src/kanban/card-surface/controls/CardActionCluster.tsx
 * FILE_ID: UI-KANBAN-CARDSURFACE-ACTIONCLUSTER-001
 * PURPOSE: Keep More and Thread as one non-wrapping card action cluster.
 * WHY: Narrow lanes must scroll/degrade the rail before detaching a blank action row.
 * FLOW: more slot + thread slot → fixed cluster at the action row edge.
 * DEPENDENCIES: react.
 * RELATED: components/KanbanCardActionZone.tsx; CardActionButton.tsx.
 */
import type { ReactNode } from 'react'

export interface CardActionClusterProps {
  moreSlot?: ReactNode
  threadSlot?: ReactNode
}

export function CardActionCluster({
  moreSlot,
  threadSlot,
}: CardActionClusterProps) {
  if (!moreSlot && !threadSlot) return null
  return (
    <div
      data-card-action-cluster=""
      className="ml-auto flex shrink-0 items-center gap-1 whitespace-nowrap"
    >
      {moreSlot}
      {threadSlot}
    </div>
  )
}
